<div class="text-sm">
  <p *ngIf="medialistLoaded && medialist.length === 0" class="text-center text-muted py-4 mb-0">
    No media has been uploaded for this course yet.
  </p>
  <!-- Members list group card -->
  <app-media-library-media *ngFor="let media of medialist" [media]="media" [enableselect]="enableselect"
  (deleteConfirmed)="deleteConfirmed($event)" (mediaSelected)="mediaSelectedHandler($event)">
  </app-media-library-media>
  <!-- <div class="card shadow-sm-darker mb-0">
  <p class="card-body mb-0 text-inherit">
    Total Media Storage Used: <span class="font-weight-600">{{schoolusedmediastorage}}</span><br>
    Total Media Storage Available: <span class="font-weight-600">{{schoolfreemediastorage}}</span><br>
    Total Media Storage Allocated: <span class="font-weight-600">{{schoolallocatedmediastorage}}</span>
  </p>
  </div> -->
</div>